import { ClientsListView } from "../../../../../../client/components/ClientsListView";
import { ClientFormType } from "../../../../../../client/enums";
import { Client } from "../../../../../../client/types";
import { VehicleInsurance } from "../../../../../types";
import { VehicleData } from "./VehicleData";

interface Props {
  insurance: VehicleInsurance;
  vehicleHolder?: Client;
  vehicleOwner?: Client;
}

export const OtherVehicleInsuranceView = ({ insurance, vehicleHolder, vehicleOwner }: Props) => {
  return (
    <>
      <VehicleData vehicle={insurance.vehicle} licensePlate={insurance.licensePlate} vin={insurance.vin} />

      {vehicleHolder && vehicleOwner && (
        <ClientsListView
          className="margin-top-medium"
          clientsData={[
            {
              client: vehicleHolder,
              clientFormTypes: [ClientFormType.HOLDER],
            },
            {
              client: vehicleOwner,
              clientFormTypes: [ClientFormType.OWNER],
            },
          ]}
        />
      )}
    </>
  );
};
